<template>
    <!--培训任务-->
  <div class="alltext">
     <div v-if="liad_show">
          <load></load>
        </div>
      <div class="firstdiv">
        <router-link :to="{path:'offlineadd',query:{num:''}}">
         <el-button type="primary" icon="el-icon-document-add" class="btnadd">制定线下任务</el-button>
        </router-link>
      </div>
      <div class="content">
       <div class="content_right">
        <div>
          <el-table :data="task_list.list" stripe style="width: 100%" :default-sort="{prop: 'num', order: 'descending'}">
             <el-table-column prop="num" label="编号" sortable>
             </el-table-column>
             <el-table-column prop="name" label="主题" sortable>
             </el-table-column>
             <el-table-column prop="t_id" label="分类" sortable>
             </el-table-column>
             <el-table-column prop="role_type" label="培训级别" sortable>
             </el-table-column>
             <el-table-column prop="type" label="类型" sortable>
             </el-table-column>
             <el-table-column prop="a_id" label="派发人" sortable>
             </el-table-column>
             <el-table-column prop="c_time" label="创建时间" sortable>
             </el-table-column>
             <el-table-column prop="start" label="开始时间" sortable>
             </el-table-column>
             <el-table-column prop="end" label="结束时间" sortable>
             </el-table-column>
             <el-table-column prop="companyee.length" label="学员数" sortable>
             </el-table-column>
             <el-table-column  label="材料" sortable>
               <template slot-scope="scope">
                 <el-button round size="mini" @click="material_see(scope.row)">查看</el-button>
               </template>
             </el-table-column>
             <el-table-column label="状态" >
                 <template slot-scope="scope">
                   <span v-if="scope.row.status=='0'">编辑中</span>
                   <span v-if="scope.row.status=='1'">启用中</span>
                   <span v-if="scope.row.status=='2'">已禁用</span>
                   <span v-if="scope.row.status=='3'">已删除</span>
                 </template>
             </el-table-column>
             <el-table-column align="center">
               <template slot="header" slot-scope="scope">
                 <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
               </template>
               <template slot-scope="scope">
                 <router-link :to="{path:'offlineadd',query:{num:scope.row.num}}" v-if="scope.row.status=='0'">
                   <i class="el-icon-edit"></i>
                 </router-link>
                 <i class="el-icon-view"  @click="train_info_watch(scope.row)" ></i>
                     <el-dropdown >
                       <span class="el-dropdown-link">
                         <i class="el-icon-more-outline" v-if="scope.row.status !='3'"></i>
                       </span>
                       <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="scope.row.status=='0'" @click.native="() => train_up('push', scope.row)">发布</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status!='0'" @click.native="() => push_status(scope.row.num)">检测</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status=='1'" @click.native="() => train_up('status', scope.row)" >禁用</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status=='2'" @click.native="() => train_up('status', scope.row)">启用</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status!='3'" @click.native="() => train_up('del',scope.row)">删除</el-dropdown-item>
                       </el-dropdown-menu>
                     </el-dropdown>
               </template>
             </el-table-column>
           </el-table>
          </div>
        </div>
      </div>
       <div class="block">
         <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
           :current-page="task_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="task_list.per_page"
           layout="total, sizes, prev, pager, next, jumper" :total="task_list.total">
         </el-pagination>
       </div>

      <el-dialog :title="nav_status.train_info_dialog.title" :visible.sync="nav_status.train_info_dialog.status">
        <div>
          培训主题：<span>{{nav_status.train_info_dialog.data.name}}</span>
        </div>
        <div>
          创建人：<span>{{nav_status.train_info_dialog.data.a_id}}</span>
        </div>
        <div>
          培训分类：<span>{{nav_status.train_info_dialog.data.type}}</span>
        </div>
        <div>
          培训级别：<span>{{nav_status.train_info_dialog.data.role_type}}</span>
        </div>
        <div>培训内容:
          <span>
            {{nav_status.train_info_dialog.data.content.content}}
          </span>
        </div>
        <div>
          培训人员：
          <!-- <span v-for="(item,key) in nav_status.train_info_dialog.data.companyee" :key="key" style="padding-right: 2rem;">
            {{item}}（已完成）
          </span> -->
          <el-table
            :data="renyuan"
             border
             height="250">
            <el-table-column
              label="序号"
              align="center"
              type="index"
              :index="indexAdd"
              width="50"/>
             </el-table-column>
            <el-table-column
              prop="name"
              label="姓名">
            </el-table-column>
          </el-table>
        </div>
        <div>
          培训说明：<span>{{nav_status.train_info_dialog.data.info}}</span>
        </div>
        <div>
          开始时间：<span>{{nav_status.train_info_dialog.data.start_time}}</span>
        </div>
        <div>
          结束时间：<span>{{nav_status.train_info_dialog.data.end_time}}</span>
        </div>
        <div>
          创建时间：<span>{{nav_status.train_info_dialog.data.c_time}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nav_status.train_info_dialog.status=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="发送状态" :visible.sync="jc_stare.dialog_show" >
       <p>总人员个人：{{jc_stare.show_list.companyee.length}} 失败个数：{{jc_stare.show_list.false_count}}</p>
         <div style="max-height: 500px;  overflow-x: auto;">
          <el-table
            ref="multipleTable"
            :data="jc_stare.show_list.companyee"
            tooltip-effect="dark"
            style="width: 100%; "
            @selection-change="handleSelectionChange"
            >
             <el-table-column
              type="selection"
              width="55"
              :selectable="selectable"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              >
            </el-table-column>
            <el-table-column label="状态">
            <template slot-scope="scope">
             <p v-if="scope.row.push" style="color: green;">成功</p>
             <p v-else style="color: red;">失败</p>
                  </template>
                </el-table-column>
          </el-table>
          </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="resend">重新发送</el-button>
          <el-button @click="jc_stare.dialog_show=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="材料详情" :visible.sync="material.show"  style="margin: 0.625rem;">
        <el-row >
          <el-row style="overflow: auto;">
            <div >
              <el-row v-if="material.type!='list'">
                <el-button  type="primary" size="mini"@click="material.type='list'" style="margin-bottom: 1.25rem;">列表</el-button>
                <el-button  type="success" size="mini"@click="updata()" style="margin-bottom: 1.25rem;" >上传</el-button>
                <el-row :style="{height:height}">
                  <el-row style="overflow: auto;">
                  <div class="el-upload__text" style="margin-bottom: 1.25rem;">您暂无材料，请先上传</div>
                  <el-upload
                  style="text-align: center;"
                    class="upload-demo"
                    drag
                    action=""
                    :file-list="material.up_list"
                    :on-change="material_chang"
                    :before-remove="material_remove"
                    :auto-upload="false"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
                  </el-upload>
                 </el-row>
                </el-row>
              </el-row>
              <el-row v-else>
                <el-button type="primary" size="mini" @click="material.type='goon'" style="margin-bottom: 1.25rem;">上传</el-button>
                <el-table
                :height="height"
                  ref="multipleTable"
                  :data="material.list"
                  tooltip-effect="dark"
                  style="width: 100%; overflow: auto;"
                  >
                  <el-table-column
                    prop="name"
                    label="姓名"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="copanyee"
                     width="100px"
                    label="上传人"
                  >
                  </el-table-column>
                  <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                   <el-button size="mini" @click="xiazai(scope.row)">下载</el-button>
                  </template>
                  </el-table-column>
                </el-table>
              </el-row>
             </div>
          </el-row>
        </el-row>

        <div slot="footer" class="dialog-footer" style="margin-top: 1.25rem;">
          <el-button @click="material.show=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="材料发送状态" :visible.sync="material.up_type_show"  :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      >
         <div style="max-height: 500px;  overflow-x: auto;">
          <el-table
            ref="multipleTable"
            :data="material.up_type_list"
            :key="material.update"
            tooltip-effect="dark"
            style="width: 100%;"
            >
            <el-table-column
              prop="name"
              label="文件名"
              >
            </el-table-column>
            <el-table-column label="状态" width="100px">
            <template slot-scope="scope">
             <p v-if="scope.row.type=='1'" style="color: green;">成功</p>
             <p v-else style="color: red;">失败</p>
                  </template>
                </el-table-column>
             <el-table-column label="操作" width="100px">
             <template slot-scope="scope">
              <el-button size="mini" @click="material_again(scope)" v-if="scope.row.type!='1'"  >重新发送</el-button>
             </template>
             </el-table-column>
          </el-table>
          </div>
        <div slot="footer" class="dialog-footer">
          <el-popconfirm title='确认关闭？'
               confirm-button-text='确定'
               cancel-button-text='取消'
               @confirm='handleClose'
               >
               <el-button slot='reference'>关 闭</el-button>
           </el-popconfirm>
          </span>

        </div>
      </el-dialog>

  </div>

</template>

<script>
import load from '../../../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        height:document.documentElement.clientHeight * 0.5+'px',
        material:{
          show:false,
          list:[],
          type:'list',
          up_list:[],
          num:'',
          up_type_show:false,
          up_type_list:[],
          update:false,
        },
        renyuan:[],
        liad_show:'',
        nav_status:{
          train_change_dialog:{
            title:'',
            status:false,
            data:[]
          },
          train_info_dialog:{
            title:'',
            status:false,
            data:{
              'content':{
                'content':{},
                'subject':{}
              },
            }
          },
          subject_list_dialog:{
            title:'',
            status:false,
            data:{},
          }
        },
        task_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        search: '',
        jc_stare:{//检测中的数据
          dialog_show:false,
          show_list:{
            companyee:[]
          },
          train:'',
          list:[]
        }
      }
    },
    components: {load:load
    },
    mounted() {
      this.get_list()
    },
    methods: {
      handleClose(){
        this.material.up_type_show=false
      },
      xiazai(item){
        window.open(item.file)
      },
      material_again(scope){
        let _this=this
        _this.material.up_type_show=true
        let  item=scope.row
        var data = new FormData();
        data.append('num',_this.material.num)
        data.append('files',item.raw)
        _this.axios.post('/v2/c_train/save_out_line_evidence',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.material.up_type_list[scope.$index].type='1'
              _this.material.update=!_this.material.update
            }else{
              _this.$message.error(res.data.msg)
              _this.material.up_type_list[scope.$index].type='0'
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
        _this.liad_show=false
      },
      updata(){
        let _this=this
        _this.material.up_type_list=[];
        if(_this.material.up_list.length==0){
          _this.$message.error('请选择上传文件');return
        }
        _this.material.up_list.forEach((item,index)=>{
          var data = new FormData();
          data.append('num',_this.material.num)
          data.append('files',item.raw)
          _this.axios.post('/v2/c_train/save_out_line_evidence',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                 item.type='1'
                _this.material.up_type_list.push(item)
              }else{
                item.type='0'
                _this.material.up_type_list.push(item)
              }
              if(index+1 == _this.material.up_list.length){
                _this.liad_show=false
                _this.material.up_list=[]
                _this.material.up_type_show=true
              }else{
                _this.liad_show=false
              }
            }else{
              _this.$message.error('服务器内部错误')
              _this.liad_show=false
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          });
        })
      },
      material_chang(file, fileList){
        this.material.up_list=fileList
      },
      material_remove(file, fileList){
         this.material.up_list=fileList
      },
      material_see(item){
        let _this=this
        _this.material.num=item.num
        _this.material.show=true
        _this.liad_show=true
        _this.axios.get('/v2/c_train/out_line_evidence',{params:{num:item.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.material.list=res.data.data
               _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
        _this.liad_show=false
      },
      indexAdd(index) {
            return index + 1
          },
      search_click(){
        this.get_list()
      },
      selectable(row){
       if(row.push){
         return false
       }else{
         return true
       }
      },
      handleSelectionChange(val) {
       this.jc_stare.list= val
      },
      resend(){
        let _this=this
        if(_this.jc_stare.list.length>0){
          _this.axios.post('/v2/c_train/train_push_companyee',{data:{'train':_this.jc_stare.train,'companyee':_this.jc_stare.list,'type':'outline'}}).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                 _this.push_status(_this.jc_stare.train)
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }else{
          _this.$message.error('请选择人员')
        }
      },
      push_status(train){
        let _this=this
        _this.jc_stare.train=train
        _this.axios.post('/v2/c_train/train_push_status',{data:{'num':train,'type':'outline'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.jc_stare.show_list=res.data.data
              _this.jc_stare.dialog_show=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      train_up(type,train){
        let _this=this;
        if( type=='del'){
          _this.$confirm('确认删除么？').then(_ => {
           _this.axios.post('/v2/c_train/train_up',{data:{'type':type,'num':train.num,'train':'outline'}}).then(function(res) {
             if(res.status=='200'){
               if(res.data.code=='1'){
                 _this.$message.success(res.data.msg)
                 _this.get_list()
               }else{
                 _this.$message.error(res.data.msg)
               }
             }else{
               _this.$message.error('服务器内部错误')
             }
           }).catch(function(error) {
             _this.$message.error('服务器内部错误')
           });
                   })
                   .catch(_ => {});
                   return

        }else{
          _this.axios.post('/v2/c_train/train_up',{data:{'type':type,'num':train.num,'train':'outline'}}).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.$message.success(res.data.msg)
                _this.get_list()
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }
      },

      get_list(){
        let _this=this;
        _this.liad_show=true
        _this.axios.get('/v2/c_train/get_list',{params:{'page':_this.task_list.current_page,'limit':_this.task_list.per_page,'type':'2','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.task_list=res.data.data
               _this.liad_show=false
              _this.task_list.per_page=parseInt(_this.task_list.per_page)
              for(let i=0;i<_this.task_list['list'].length;i++){
                _this.task_list['list'][i]['number']=_this.task_list['list'][i]['companyee'].length;
                if(_this.task_list['list'][i].role_type=='0'){
                  _this.task_list['list'][i].role_type="企业级"
                }else if(_this.task_list['list'][i].role_type=='1'){
                   _this.task_list['list'][i].role_type="部门级"
                }else if(_this.task_list['list'][i].role_type=='2'){
                   _this.task_list['list'][i].role_type="个人级"
                }
              }
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_train_info(num){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_train/get_train_info',{params:{'num':num,'type':'outline'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.liad_show=false
              _this.$set(_this.nav_status.train_info_dialog,'data',res.data.data)
              _this.nav_status.train_info_dialog.status=true
              if(res.data.data.companyee.length>0){
                for(let i=0;i<res.data.data.companyee.length;i++){
                  let data={
                    name:res.data.data.companyee[i],
                    num:i
                  }
                  _this.renyuan[i]=data
                }
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      train_info_watch(train){
        this.nav_status.train_info_dialog.title=train.name
        this.get_train_info(train.num)
      },

      train_companyee_remove(train,companyee){
        let _this=this
        _this.axios.post('/v2/c_train/del_train_companee',{data:{'train':train.num,'companyee':_this.nav_status.train_info_dialog.data.companyee[companyee].num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.train_info_dialog.data.companyee.splice(companyee, 1);
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      subject_list(train,companyee){
        let _this=this
        _this.axios.get('/v2/c_train/get_train_companyee_exam',{params:{'train':train.num,'companyee':companyee.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.nav_status.subject_list_dialog.title=companyee.name+'['+train.name+']的考核试卷列表'
              _this.$set(_this.nav_status.subject_list_dialog,'data',res.data.data)
              _this.nav_status.subject_list_dialog.status=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      subject_watch(subject){
        this.$message.success('获取试卷详情')
      },

      subject_remove(subject){
        let _this=this
        _this.axios.post('/v2/c_train/del_train_companyee_exam',{data:_this.nav_status.subject_list_dialog.data[subject].num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.subject_list_dialog.data.splice(subject, 1);
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      handleSizeChange(val) {
        this.task_list.current_page = 1;
        this.task_list.per_page = val;
        this.get_list();
      },
      handleCurrentChange(val) {
        let _this=this
        _this.task_list.current_page = val;
        _this.get_list();
      },
    }
  }
</script>

<style scoped>
  .block{
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .alltext{
    margin: 20px;
    background-color: white;
    height: 100%;
    width: 95%;
    border:1px solid 	#9D9D9D;
  }
  .firstdiv{
    margin-top: 10px;

    width: 95%;
    height: 70px;
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
  .content{
    width: 100%;
  }
  .content_right_first{
      margin: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .content_right{

      padding: 20px;
    }
    /deep/ ::-webkit-scrollbar {
      /* 滚动条整体样式 */
      width: 6px;
      /* 宽高分别对应横竖滚动条的尺寸 */
      background: rgb(235, 238, 245);
      border-radius: 10px;
      -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
    }
    /deep/ ::-webkit-scrollbar-thumb {
      /* 滚动条里的小方块 */
      border-radius: 3px;
      background: #bbb;
      height: 120px;
    }
    /deep/ ::-webkit-scrollbar-track {
      /* 滚动条里面的轨道 */
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.1);
    }
</style>



// WEBPACK FOOTER //
// src/view/company/train/Offline/Offline.vue